// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".itemBox[data-v-2d260361]{padding:5px 0;min-height:100px;max-height:135px;overflow:auto}.itemBox .dragItem[data-v-2d260361]{width:100%;height:30px;display:inline-block;line-height:30px;padding:0 15px;font-size:12px;cursor:pointer}.itemBox .dragItem[data-v-2d260361]:hover{background:#ddd;cursor:pointer}.btns[data-v-2d260361]{margin-left:23px;margin-bottom:15px}", ""]);
// Exports
module.exports = exports;
